import { getPassengerDetailsAction } from "../Checkout/PassengerDetails/GetPassengerDetailsAction";

/**
 * Drop the session-scoped in-memory user caches after any mutation of the
 * logged-in customer.
 *
 * Two singleton actions cache the user for the lifetime of the page session:
 * getPassengerDetailsAction (`_cached`) and getUserDetailsAction (`_cachedUser`).
 * After the first /me fetch, every later execute() REPLAYS its cached copy into
 * userDataAtom. So when a mutation writes the fresh response into userDataAtom
 * but leaves these caches stale, the next execute() — fired by Topbar's auth
 * effect or MyAccount.Init on the next navigation — overwrites the saved value
 * with the pre-mutation user, and the change appears to revert until a full
 * page reload clears module memory.
 *
 * getPassengerDetailsAction.invalidate() clears its own cache and chains to
 * getUserDetailsAction.invalidate(), so this single call clears both. Call it
 * after a successful customer mutation, before the next execute() can replay.
 */
export function invalidateUserCaches(): void {
    getPassengerDetailsAction.invalidate();
}
